import {
  tryOnScopeDispose,
  unrefElement,
  useDebounceFn,
  useEventListener
} from "@vueuse/core";
import {
  default as SplitType
} from "split-type";
import { computed, ref, watch } from "vue";
export function useSplitText(target, options) {
  const instance = ref();
  const lines = computed(() => instance.value?.lines);
  const words = computed(() => instance.value?.words);
  const chars = computed(() => instance.value?.chars);
  const split = (options2) => {
    instance.value?.split(options2);
    if (!!instance.value && !!wrapping)
      wrapFn(instance.value);
  };
  const revert = () => instance.value?.revert();
  const { splitBy, wrapping, onComplete } = options;
  const wrapFn = (instance2) => {
    if (["chars", "words"].every((sp) => splitBy.includes(sp)))
      for (const el of instance2.words ?? []) {
        el.style.display = "inline-flex";
      }
    if (!wrapping)
      return;
    instance2[wrapping.select]?.forEach((childEl, index) => {
      const wrapEl = document.createElement(wrapping.wrapType ?? "span");
      if (wrapping.selectElClass)
        childEl.classList.add(...wrapping.selectElClass.split(" "));
      if (wrapping.wrapClass)
        wrapEl.classList.add(...wrapping.wrapClass.split(" "));
      wrapEl.dataset[`${wrapping.select}Index`] = `${index}`;
      childEl.parentNode?.appendChild(wrapEl);
      wrapEl.appendChild(childEl);
    });
  };
  watch(
    () => unrefElement(target),
    (el) => {
      if (!el)
        return;
      instance.value = new SplitType(el, {
        types: splitBy,
        ...options.splitOptions
      });
      split({});
      onComplete?.(instance.value);
    },
    { immediate: true, flush: "post" }
  );
  const resizeFn = useDebounceFn(() => {
    split({});
  }, 500);
  useEventListener("resize", resizeFn, { passive: true });
  tryOnScopeDispose(revert);
  return {
    instance,
    lines,
    words,
    chars,
    split,
    revert
  };
}
